import actions from './actions';
import types from './constants';

const setIsListening = (isListening) => (dispatch) => {
  dispatch(actions[types.IS_LISTENING_CHANGE](isListening));
}

export default {
  setIsListening,
}
